module.exports = __webpack_public_path__ + "img/home-page-header-bg.b685f67f.png";